import { Directive, OnInit, input, signal } from '@angular/core';

import { Subject } from 'rxjs';

import { CamAbstractInput } from '@camelot/form-model';
import { CamBaseComponent } from '@camelot/utils';

interface Department {
  id: number;
  name: string | null;
  iconPath: string | null;
}

@Directive()
export abstract class BaseTemplateComponent extends CamBaseComponent implements OnInit {
  items = input.required<
    {
      id: number;
      department?: Department;
      professions?: string[];
    }[]
  >();

  formSubmit$ = input<Subject<null>>();

  public askValidation$ = new Subject<null>();

  public form = signal<CamAbstractInput[] | null>(null);

  get currentItem() {
    return this.items()[this._itemIndex];
  }

  get haveMore() {
    return !!this.items()[this._itemIndex + 1];
  }

  private _itemIndex: number = 0;

  public isValidForm: boolean = false;

  ngOnInit(): void {
    this.setForm();
  }

  public next() {
    this.isValidForm = false;
    if (!this.haveMore) {
      this._close();
      return;
    }
    this._itemIndex++;

    this.setForm();
  }

  public askValidation(): void {
    this.askValidation$.next(null);
  }

  public cancel(): void {
    this._close();
  }

  public formValid(value: boolean) {
    this.isValidForm = value;
  }

  private _close() {
    this.formSubmit$()?.next(null);
  }

  abstract send(data?: any): void;
  abstract setForm(): void;
}
